export const addpackagetranslation = {
  en: {
    name: "Name",
    description: "Description",
    category: "Category",
    subcategory: "Subcategory",
    thumbnail: "Thumbnail",
    discard: "Discard",
    save: "Save",
    setPackageName: "Set package name",
    setPackageDescription: "Set package description",
    setStepName: "Set step name",
    title: "List of packages",
    title1: "Add package",
    addPackage: "+ Add package",
    details: "Details",
    steps: "Steps",
    addStep: "Add step",
    type: "Type",
    thumbnailDrop: "Drag & Drop your image here or click to select",
    file: "File",
    uploadFile: "Upload new file",
    cancel: "Cancel",
    confirm: "Confirm",
    deleteConfirmation:
      'Are you sure you want to delete the package "{label}"?',
    rotation: "Rotation",
    packageSuccess: "Package was created successfully!",
    packageEditedSuccess: "Package was edited successfully!",
    noteAnimationFile: "Note, this file is only needed if object has animation",
  },
  ru: {
    name: "Название",
    description: "Описание",
    category: "Категория",
    subcategory: "Подкатегория",
    thumbnail: "Миниатюра",
    discard: "Отменить",
    save: "Сохранить",
    setPackageName: "Установить название пакета",
    setPackageDescription: "Установить описание пакета",
    setStepName: "Установить название шага",
    title: "Список пакетов",
    title1: "Добавить пакет",
    addPackage: "+ Добавить пакет",
    details: "Детали",
    steps: "Шаги",
    addStep: "Добавить шаг",
    type: "Тип",
    thumbnailDrop: "Перетащите изображение сюда или нажмите для выбора",
    file: "Файл",
    uploadFile: "Загрузить новый файл",
    cancel: "Отменить",
    confirm: "Подтвердить",
    deleteConfirmation: 'Вы уверены, что хотите удалить пакет "{label}"?',
    rotation: "Вращение",
    packageSuccess: "Пакет был успешно создан!",
    packageEditedSuccess: "Пакет был успешно отредактирован!",
    noteAnimationFile:
      "Этот файл нужен только в случае, если объект имеет анимацию",
  },
  cz: {
    name: "Název",
    description: "Popis",
    category: "Kategorie",
    subcategory: "Podkategorie",
    thumbnail: "Thumbnail",
    discard: "Zahodit",
    save: "Uložit",
    setPackageName: "Nastavit název balíčku",
    setPackageDescription: "Nastavit popis balíčku",
    setStepName: "Nastavit název kroku",
    title: "Seznam balíčků",
    title1: "Přidat balíček",
    addPackage: "+ Přidat balíček",
    details: "Detaily",
    steps: "Kroky",
    addStep: "Přidat krok",
    type: "Typ",
    thumbnailDrop: "Přetáhněte obrázek sem nebo klikněte pro výběr",
    file: "Soubor",
    uploadFile: "Nahrát nový soubor",
    cancel: "Zrušit",
    confirm: "Potvrdit",
    deleteConfirmation: 'Opravdu chcete smazat balíček "{label}"?',
    rotation: "Rotace",
    packageSuccess: "Balíček byl úspěšně vytvořen!",
    packageEditedSuccess: "Balíček byl úspěšně upraven!",
    noteAnimationFile:
      "Všimněte si, že tento soubor je potřeba pouze tehdy, pokud má objekt animaci.",
  },
  sk: {
    name: "Názov",
    description: "Popis",
    category: "Kategória",
    subcategory: "Podkategória",
    thumbnail: "Thumbnail",
    discard: "Zahodiť",
    save: "Uložiť",
    setPackageName: "Nastaviť názov balíka",
    setPackageDescription: "Nastaviť popis balíka",
    setStepName: "Nastaviť názov kroku",
    title: "Zoznam balíkov",
    title1: "Pridať balík",
    addPackage: "+ Pridať balík",
    details: "Detaily",
    steps: "Kroky",
    addStep: "Pridať krok",
    type: "Typ",
    thumbnailDrop: "Pretiahnite svoj obrázok sem alebo kliknite pre výber",
    file: "Súbor",
    uploadFile: "Nahrať nový súbor",
    cancel: "Zrušiť",
    confirm: "Potvrdiť",
    deleteConfirmation: 'Ste si istý, že chcete odstrániť balík "{label}"?',
    rotation: "Rotácia",
    packageSuccess: "Balík bol úspešne vytvorený!",
    packageEditedSuccess: "Balík bol úspešne upravený!",
    noteAnimationFile:
      "Všimnite si, že tento súbor je potrebný iba vtedy, ak má objekt animáciu.",
  },
  de: {
    name: "Name",
    description: "Beschreibung",
    category: "Kategorie",
    subcategory: "Unterkategorie",
    thumbnail: "Thumbnail",
    discard: "Verwerfen",
    save: "Speichern",
    setPackageName: "Paketnamen festlegen",
    setPackageDescription: "Paketbeschreibung festlegen",
    setStepName: "Schrittnamen festlegen",
    title: "Liste der Pakete",
    title1: "Paket hinzufügen",
    addPackage: "+ Paket hinzufügen",
    details: "Einzelheiten",
    steps: "Schritte",
    addStep: "Schritt hinzufügen",
    type: "Typ",
    thumbnailDrop: "Ziehen Sie Ihr Bild hierher oder klicken Sie zum Auswählen",
    file: "Datei",
    uploadFile: "Neue Datei hochladen",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    deleteConfirmation:
      'Sind Sie sicher, dass Sie das Paket "{label}" löschen möchten?',
    rotation: "Drehung",
    packageSuccess: "Paket wurde erfolgreich erstellt!",
    packageEditedSuccess: "Paket wurde erfolgreich bearbeitet!",
    noteAnimationFile:
      "Beachten Sie, dass diese Datei nur benötigt wird, wenn das Objekt eine Animation hat.",
  },
  hu: {
    name: "Név",
    description: "Leírás",
    category: "Kategória",
    subcategory: "Alkategória",
    thumbnail: "Thumbnail",
    discard: "Elvet",
    save: "Mentés",
    setPackageName: "Csomag neve",
    setPackageDescription: "Csomag leírása",
    setStepName: "Lépés neve",
    title: "Csomagok listája",
    title1: "Csomag hozzáadása",
    addPackage: "+ Csomag hozzáadása",
    details: "Részletek",
    steps: "Lépések",
    addStep: "Lépés hozzáadása",
    type: "Típus",
    thumbnailDrop: "Húzza ide a képet vagy kattintson a kiválasztáshoz",
    file: "Fájl",
    uploadFile: "Új fájl feltöltése",
    cancel: "Mégse",
    confirm: "Megerősít",
    deleteConfirmation: 'Biztos benne, hogy törli a csomagot "{label}"?',
    rotation: "Forgatás",
    packageSuccess: "A csomag sikeresen létrejött!",
    packageEditedSuccess: "A csomag sikeresen szerkesztve lett!",
    noteAnimationFile:
      "Ne feledje, hogy erre a fájlra csak akkor van szükség, ha az objektumnak van animációja.",
  },
  pl: {
    name: "Nazwa",
    description: "Opis",
    category: "Kategoria",
    subcategory: "Podkategoria",
    thumbnail: "Thumbnail",
    discard: "Odrzuć",
    save: "Zapisz",
    setPackageName: "Ustaw nazwę pakietu",
    setPackageDescription: "Ustaw opis pakietu",
    setStepName: "Ustaw nazwę kroku",
    title: "Lista pakietów",
    title1: "Dodaj pakiet",
    addPackage: "+ Dodaj pakiet",
    details: "Szczegóły",
    steps: "Kroki",
    addStep: "Dodaj krok",
    type: "Typ",
    thumbnailDrop: "Przeciągnij i upuść obraz tutaj lub kliknij, aby wybrać",
    file: "Plik",
    uploadFile: "Prześlij nowy plik",
    cancel: "Anuluj",
    confirm: "Potwierdź",
    deleteConfirmation: 'Czy na pewno chcesz usunąć pakiet "{label}"?',
    rotation: "Rotacja",
    packageSuccess: "Paczka została pomyślnie utworzona!",
    packageEditedSuccess: "Paczka została pomyślnie edytowana!",
    noteAnimationFile:
      "Zauważ, że ten plik jest potrzebny tylko wtedy, gdy obiekt ma animację.",
  },
  fr: {
    name: "Nom",
    description: "Description",
    category: "Catégorie",
    subcategory: "Sous-catégorie",
    thumbnail: "Thumbnail",
    discard: "Jeter",
    save: "Enregistrer",
    setPackageName: "Définir le nom du paquet",
    setPackageDescription: "Définir la description du paquet",
    setStepName: "Définir le nom de l'étape",
    title: "Liste des paquets",
    title1: "Ajouter un paquet",
    addPackage: "+ Ajouter un paquet",
    details: "Détails",
    steps: "Étapes",
    addStep: "Ajouter une étape",
    type: "Type",
    thumbnailDrop:
      "Glissez et déposez votre image ici ou cliquez pour sélectionner",
    file: "Fichier",
    uploadFile: "Télécharger un nouveau fichier",
    cancel: "Annuler",
    confirm: "Confirmer",
    deleteConfirmation:
      'Êtes-vous sûr de vouloir supprimer le paquet "{label}"?',
    rotation: "Rotation",
    packageSuccess: "Le paquet a été créé avec succès !",
    packageEditedSuccess: "Le paquet a été modifié avec succès!",
    noteAnimationFile:
      "Notez que ce fichier n'est nécessaire que si l'objet a une animation.",
  },
  es: {
    name: "Nombre",
    description: "Descripción",
    category: "Categoría",
    subcategory: "Subcategoría",
    thumbnail: "Thumbnail",
    discard: "Descartar",
    save: "Guardar",
    setPackageName: "Establecer nombre del paquete",
    setPackageDescription: "Establecer descripción del paquete",
    setStepName: "Establecer nombre del paso",
    title: "Lista de paquetes",
    title1: "Añadir paquete",
    addPackage: "+ Añadir paquete",
    details: "Detalles",
    steps: "Pasos",
    addStep: "Añadir paso",
    type: "Tipo",
    thumbnailDrop:
      "Arrastra y suelta tu imagen aquí o haz clic para seleccionar",
    file: "Archivo",
    uploadFile: "Subir nuevo archivo",
    cancel: "Cancelar",
    confirm: "Confirmar",
    deleteConfirmation:
      '¿Estás seguro de que deseas eliminar el paquete "{label}"?',
    rotation: "Rotación",
    packageSuccess: "¡El paquete se creó con éxito!",
    packageEditedSuccess: "¡El paquete se editó con éxito!",
    noteAnimationFile:
      "Tenga en cuenta que este archivo solo es necesario si el objeto tiene animación.",
  },
  nl: {
    name: "Naam",
    description: "Beschrijving",
    category: "Categorie",
    subcategory: "Subcategorie",
    thumbnail: "Thumbnail",
    discard: "Verwijderen",
    save: "Opslaan",
    setPackageName: "Pakketnaam instellen",
    setPackageDescription: "Pakketbeschrijving instellen",
    setStepName: "Stel stapnaam in",
    title: "Lijst van pakketten",
    title1: "Pakket toevoegen",
    addPackage: "+ Pakket toevoegen",
    details: "Details",
    steps: "Stappen",
    addStep: "Stap toevoegen",
    type: "Type",
    thumbnailDrop: "Sleep je afbeelding hierheen of klik om te selecteren",
    file: "Bestand",
    uploadFile: "Nieuw bestand uploaden",
    cancel: "Annuleren",
    confirm: "Bevestigen",
    deleteConfirmation:
      'Weet je zeker dat je het pakket "{label}" wilt verwijderen?',
    rotation: "Rotatie",
    packageSuccess: "Pakket is succesvol aangemaakt!",
    packageEditedSuccess: "Pakket is succesvol bewerkt!",
    noteAnimationFile:
      "Let op, dit bestand is alleen nodig als het object animatie heeft.",
  },
  sv: {
    name: "Namn",
    description: "Beskrivning",
    category: "Kategori",
    subcategory: "Underkategori",
    thumbnail: "Miniatyrbild",
    discard: "Kassera",
    save: "Spara",
    setPackageName: "Ange paketnamn",
    setPackageDescription: "Ange paketbeskrivning",
    setStepName: "Ange stegnamn",
    title: "Lista över paket",
    title1: "Lägg till paket",
    addPackage: "+ Lägg till paket",
    details: "Detaljer",
    steps: "Steg",
    addStep: "Lägg till steg",
    type: "Typ",
    thumbnailDrop: "Dra och släpp din bild här eller klicka för att välja",
    file: "Fil",
    uploadFile: "Ladda upp ny fil",
    cancel: "Avbryt",
    confirm: "Bekräfta",
    deleteConfirmation: 'Är du säker på att du vill ta bort paketet "{label}"?',
    rotation: "Rotation",
    packageSuccess: "Paketet skapades framgångsrikt!",
    packageEditedSuccess: "Paketet redigerades framgångsrikt!",
    noteAnimationFile:
      "Observera att denna fil endast behövs om objektet har animation.",
  },
  no: {
    name: "Navn",
    description: "Beskrivelse",
    category: "Kategori",
    subcategory: "Underkategori",
    thumbnail: "Miniatyrbilde",
    discard: "Forkast",
    save: "Lagre",
    setPackageName: "Angi pakkenavn",
    setPackageDescription: "Angi pakke beskrivelse",
    setStepName: "Angi trinnnavn",
    title: "Liste over pakker",
    title1: "Legg til pakke",
    addPackage: "+ Legg til pakke",
    details: "Detaljer",
    steps: "Steg",
    addStep: "Legg til trinn",
    type: "Type",
    thumbnailDrop: "Dra og slipp bildet ditt her eller klikk for å velge",
    file: "Fil",
    uploadFile: "Last opp ny fil",
    cancel: "Avbryt",
    confirm: "Bekreft",
    deleteConfirmation: 'Er du sikker på at du vil slette pakken "{label}"?',
    rotation: "Rotasjon",
    packageSuccess: "Pakken ble opprettet!",
    packageEditedSuccess: "Pakken ble redigert!",
    noteAnimationFile:
      "Vær oppmerksom på at denne filen bare er nødvendig hvis objektet har animasjon.",
  },
  da: {
    name: "Navn",
    description: "Beskrivelse",
    category: "Kategori",
    subcategory: "Underkategori",
    thumbnail: "Miniature",
    discard: "Kassér",
    save: "Gem",
    setPackageName: "Indstil pakkenavn",
    setPackageDescription: "Indstil pakkebeskrivelse",
    setStepName: "Indstil trin navn",
    title: "Liste over pakker",
    title1: "Tilføj pakke",
    addPackage: "+ Tilføj pakke",
    details: "Detaljer",
    steps: "Trin",
    addStep: "Tilføj trin",
    type: "Type",
    thumbnailDrop: "Træk og slip dit billede her eller klik for at vælge",
    file: "Fil",
    uploadFile: "Upload ny fil",
    cancel: "Annuller",
    confirm: "Bekræft",
    deleteConfirmation: 'Er du sikker på, at du vil slette pakken "{label}"?',
    rotation: "Rotation",
    packageSuccess: "Pakken blev oprettet!",
    packageEditedSuccess: "Pakken blev redigeret!",
    noteAnimationFile:
      "Bemærk, at denne fil kun er nødvendig, hvis objektet har animation.",
  },
  fi: {
    name: "Nimi",
    description: "Kuvaus",
    category: "Kategoria",
    subcategory: "Alakategoria",
    thumbnail: "Esikatselukuva",
    discard: "Hylkää",
    save: "Tallenna",
    setPackageName: "Määritä paketin nimi",
    setPackageDescription: "Määritä paketin kuvaus",
    setStepName: "Määritä vaiheen nimi",
    title: "Pakettilista",
    title1: "Lisää paketti",
    addPackage: "+ Lisää paketti",
    details: "Tiedot",
    steps: "Vaiheet",
    addStep: "Lisää vaihe",
    type: "Tyyppi",
    thumbnailDrop: "Vedä ja pudota kuvasi tähän tai valitse napsauttamalla",
    file: "Tiedosto",
    uploadFile: "Lataa uusi tiedosto",
    cancel: "Peruuta",
    confirm: "Vahvista",
    deleteConfirmation: 'Oletko varma, että haluat poistaa paketin "{label}"?',
    rotation: "Kierto",
    packageSuccess: "Paketti luotiin onnistuneesti!",
    packageEditedSuccess: "Paketti muokattiin onnistuneesti!",
    noteAnimationFile:
      "Huomaa, että tämä tiedosto on tarpeen vain, jos objektissa on animaatio.",
  },
  ar: {
    name: "الاسم",
    description: "الوصف",
    category: "الفئة",
    subcategory: "الفئة الفرعية",
    thumbnail: "صورة مصغرة",
    discard: "تجاهل",
    save: "حفظ",
    setPackageName: "تعيين اسم الحزمة",
    setPackageDescription: "تعيين وصف الحزمة",
    setStepName: "تعيين اسم الخطوة",
    title: "قائمة الحزم",
    title1: "إضافة حزمة",
    addPackage: "+ إضافة حزمة",
    details: "التفاصيل",
    steps: "الخطوات",
    addStep: "إضافة خطوة",
    type: "النوع",
    thumbnailDrop: "اسحب وأفلت الصورة هنا أو انقر لتحديد",
    file: "الملف",
    uploadFile: "تحميل ملف جديد",
    cancel: "إلغاء",
    confirm: "تأكيد",
    deleteConfirmation: 'هل أنت متأكد أنك تريد حذف الحزمة "{label}"؟',
    rotation: "دوران",
    packageSuccess: "تم إنشاء الحزمة بنجاح!",
    packageEditedSuccess: "تم تعديل الحزمة بنجاح!",
    noteAnimationFile:
      "ملاحظة، هذا الملف مطلوب فقط إذا كان الكائن يحتوي على حركة.",
  },
};

export default addpackagetranslation;
